<template>
  <div class="flex flex-col gap-2 p-2">
    <div class="flex w-full items-center gap-2 p-2">
      <FontAwesomeIcon
        :icon="['far', 'magnifying-glass']"
        size="sm"
      />
      <input-text
        v-model="search_query"
        :placeholder="$t('navbar.topnavbar.selectTeam')"
        size="small"
      />
    </div>
    <div
      v-for="tenant in tenants_filtered"
      :key="`${tenant.id}-${tenant.type}`"
      class="hover:bg-gray-200"
    >
      <a :href="urlTenant(tenant)">
        <div
          :class="{ 'bg-gray-100': subdomain === tenant.attributes.subdomain }"
          class="flex cursor-pointer gap-2 p-2"
        >
          <figure
            class="image is-16x16"
            style="margin-top: 0.25rem"
          >
            <img
              :src="tenant.attributes.picture_favicon_url"
              alt="favicon-engage"
            />
          </figure>
          <div class="media-content font-medium">
            {{ tenant.attributes.name }}
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import Modal from '@/app/shared_components/modals/TheModal.vue';
import { mapActions, mapGetters } from 'vuex';
import { PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';
import { VITE_ENV_REVIEW } from '@/app/data/general_constants';
import { ZIGGU_PARENT_URL, zigguProfileTenantURL } from '@/app/util/urls';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'SelectTenant',

  components: {
    FontAwesomeIcon,
    Modal,
  },

  data() {
    return {
      initialized: false,
      PROFILE_TYPES,
      zigguProfileTenantURL,
      search_query: '',
    };
  },

  computed: {
    ...mapGetters([
      'current_is_impersonation',
      'current_profile',
      'current_user',
      'current_user_customers',
      'current_user_employees',
      'current_user_partners',
      'current_user_supervisors',
      'current_user_clients',
      'current_user_projects',
      'current_user_tenants',
      'current_user_profiles',
    ]),

    email_address() {
      return this.is_parent_domain
        ? this.current_user.attributes.email_address
        : this.current_profile.attributes.email_address;
    },

    is_parent_domain() {
      return ZIGGU_PARENT_URL === window.location.origin;
    },

    origin() {
      return window.location.origin;
    },

    subdomain() {
      let _subdomain = null;
      const parts = window.location.host.split('.');
      if (import.meta.env.VITE_ENV === VITE_ENV_REVIEW) {
        if (parts.length > 3) [_subdomain] = parts;
      } else if (parts.length === 3) {
        [_subdomain] = parts;
      }
      return _subdomain;
    },

    profiles() {
      const profiles = [
        Object.values(this.current_user_supervisors),
        Object.values(this.current_user_employees),
        Object.values(this.current_user_customers),
        Object.values(this.current_user_partners),
      ];
      return [].concat(...profiles);
    },

    tenants_filtered() {
      if (!this.current_user_tenants) {
        return [];
      }
      return _.filter(this.current_user_tenants, (tenant) =>
        tenant.attributes.name.toLowerCase().includes(this.search_query.toLowerCase()),
      );
    },
  },

  created() {
    // Profile fetching is now handled by parent SelectTenantModal
    this.initialized = true;
  },

  methods: {
    ...mapActions(['LOGOUT_USER']),

    urlTenant(tenant) {
      const profile = this.getProfile(tenant);
      const url = this.zigguProfileTenantURL(profile, tenant);
      // append meta query params on impersonation for non-supervisor profiles
      if (this.current_is_impersonation && tenant.attributes.subdomain !== 'supervisor') {
        return `${url}?_profile_type=${profile.type}&_profile_id=${profile.id}`;
      }
      return url;
    },

    getProfile(tenant) {
      if (tenant.attributes.name === 'supervisor') return _.values(this.current_user_supervisors)[0];

      const client_id =
        tenant.attributes.tenantable_type === RECORD_TYPE.PROJECT
          ? this.current_user_projects[tenant.attributes.tenantable_id].attributes.client_id
          : tenant.attributes.tenantable_id;
      return _.find(this.profiles, ['attributes.client_id', client_id]);
    },
  },
};
</script>
